export const scrollToSection = (selector) => {
  document.querySelector(selector)?.scrollIntoView({ behavior: "smooth" });
};
